<template>
  <div>
    <div v-if="allowedState.length > 2" class="state-menu state-menu col-md-12">
      <nav
        class="navbar navbar-expand navbar-light bg-light"
        style="padding: 0px;"
      >
        <button
          class="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav mr-auto mt-2 mt-lg-0">
            <li class="nav-item" v-for="st in this.allowedState" :key="st">
              <a
                class="nav-link"
                style="padding-left: 0.38rem; padding-right: 0.38rem;"
                :class="{ active: activeState === st }"
                @click.prevent="filterStore(st)"
                href="#"
                >{{ st == "All" ? $t("message.all") : st }}</a
              >
            </li>
          </ul>
        </div>
      </nav>
    </div>
    <div
      v-if="show"
      class="mobile-resturants container"
      :style="restaurantsContainerStyles"
    >
      <div
        v-for="rs in orderedResturants"
        :key="rs.ID"
        class="row"
        @click="navigateToStore(rs)"
      >
        <div class="triangle-container"  v-if="storeClosed(rs)">
          <div
            class="triangle-topright-img"
          >
            <span>
              {{ $t("message.closed") }}
            </span>
          </div>
        </div>
        <div class="item">
          <div
            v-if="rs.ProfileImage"
            class="item-img"
            :style="{ 'background-image': 'url(' + rs.ProfileImage + ')' }"
          ></div>
          <div class="item-details with-image">
            <h2 class="item-title">{{ rs.Name }}</h2>
            <p class="item-subtitle">{{ rs.StoreTitle }}</p>
            <p class="item-subtitle">
              {{ rs.Location.Address }}
              <br />
              {{ rs.Location.Suburb }} {{ rs.Location.State }}
            </p>
          </div>
          <h2 class="item-hours">
            <div v-if="getOperatingHours(rs)" class="color-gray">
              {{ $t("message.open") }}
              <span>{{ getOperatingHours(rs).openTime }}</span>
              {{ $t("message.toName") }}
              <span>{{ getOperatingHours(rs).closeTime }}</span>
            </div>
          </h2>
          <span v-if="pos" class="item-loc">
            <span class="material-icons">near_me</span>
            {{ distance(rs.Location.Latitude, rs.Location.Longitude) }}km
            {{ $t("message.away") }}
          </span>
        </div>
      </div>
    </div>
    <div v-else>
      <message :message="getNoStoreAvailableInDatabaseLang" v-show="!busy" />
      <progressindicator
        v-show="busy"
        style="opacity: 0.4;"
      ></progressindicator>
    </div>
  </div>
</template>

<script>
import shared from "../../../sharedscripts/master/Resturant/ResturantsFilter.js";
import Progressindicator from "../../progressindicator";
import Message from "../../shared/Message";

export default {
  components: { Progressindicator, Message },
  filters: {
    ...shared.filters,
  },
  props: {
    filterQuery: {
      type: String,
      default: "all",
    },
    activeState: {
      type: String,
      default: "All",
    },
  },
  data() {
    return {
      populars: [],
      pos: null,
      busy: false,
      states: ["All", "ACT", "NSW", "NT", "QLD", "SA", "TAS", "VIC", "WA"],
    };
  },
  computed: {
    ...shared.computed,
    hasLogo() {
      return this.hqDoc ? this.hqDoc.Logo : null;
    },
    restaurantsContainerStyles() {
      return this.hasLogo ? {'margin-top': '43px'} : {'margin-top': '-13px'};
    },
  },
  watch: {
    filterQuery(newValue) {
      this.populars = [];
      if (newValue === "all") {
        this.getStores();
      } else {
        this.getnearStores();
      }
    },
  },
  created() {
    this.checkLocation();
    this.getStores();
  },
  methods: {
    ...shared.methods,
  },
};
</script>
